import { IState } from '../state/state';
import { createSelector } from '@ngrx/store';
import { IMaps } from 'src/app/models/map';

export const mapsSelector = (state: IState) => state.appData.maps;
export const mapsMessage = createSelector(mapsSelector, (state: IMaps) => state.message);
export const mapsPayload = createSelector(mapsSelector, (state: IMaps) => state.payload);
export const productLines = createSelector(mapsSelector, (state: IMaps) => state.payload?.productLines);
export const workingStatuses = createSelector(mapsSelector, (state: IMaps) => state.payload?.workingStatuses);
export const facilityTypes = createSelector(mapsSelector, (state: IMaps) => state.payload?.facilityTypes);
export const countries = createSelector(mapsSelector, (state: IMaps) => state.payload?.countries);
export const quarantineLocation = createSelector(mapsSelector, (state: IMaps) => state.payload?.quarantineLocations);
export const quarantineBy = createSelector(mapsSelector, (state: IMaps) => state.payload?.quarantineBy);
export const permissions = createSelector(mapsSelector, (state: IMaps) => state.payload?.permissions);
export const travelTypes = createSelector(mapsSelector, (state: IMaps) => state.payload?.travelTypes);
export const travelApproverTypes = createSelector(mapsSelector, (state: IMaps) => state.payload?.travelRequestApproverTypes);
export const travelRequestStatuses = createSelector(mapsSelector, (state: IMaps) => state.payload?.travelRequestStatuses);
export const travelRequestActions = createSelector(mapsSelector, (state: IMaps) => state.payload?.travelRequestActions);








